import { Badge, BadgeType } from '@shared/badge';

import { TransactionStatus } from '@core/models/transaction';

export const TransactionStatusMap: Record<string, Badge<TransactionStatus>> = {
  [TransactionStatus.PENDING]: {
    key: TransactionStatus.PENDING,
    value: 'Pending',
    type: BadgeType.PROGRESS,
  },
  [TransactionStatus.SUCCESS]: {
    key: TransactionStatus.SUCCESS,
    value: 'Success',
    type: BadgeType.SUCCESS,
  },
  [TransactionStatus.FAILED]: {
    key: TransactionStatus.FAILED,
    value: 'Failed',
    type: BadgeType.ERROR,
  },
};
